export default __webpack_public_path__ + "static/logo-small-a6dd267d2f14492b5cddfe30c7ba0c39.png";